import {defineStore} from 'pinia';

export const useContainersStore = defineStore('containersStore', {
  state: () => ({
    container: null
  }),

  actions: {
    async getContainer({id, userId, shareToken}) {
      const container = await useContainerApi().getContainer({id, userId, shareToken});

      container.isOwnedByUser = container.user?.id === useSessionStore().currentUser?.id;

      this.container = container;

      return this.container;
    }
  }
});
